import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import IndividualTours from "@/pages/IndividualTours";
import CorporateTours from "@/pages/CorporateTours";
import SchoolTours from "@/pages/SchoolTours";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Education from "@/pages/Education";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import GiftVouchers from "@/pages/GiftVouchers";
import GiftVoucherSuccess from "@/pages/GiftVoucherSuccess";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Quiz from "@/pages/Quiz";
import SchoolBookingSuccess from "@/pages/SchoolBookingSuccess";
import CorporateBookingSuccess from "@/pages/CorporateBookingSuccess";
import LeaveReview from "@/pages/LeaveReview";
import YesteryearTalks from "@/pages/YesteryearTalks";
import YesteryearBookingSuccess from "@/pages/YesteryearBookingSuccess";

function App() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/individual" element={<IndividualTours />} />
            <Route path="/corporate" element={<CorporateTours />} />
            <Route path="/school" element={<SchoolTours />} />
            <Route path="/education" element={<Education />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gift-vouchers" element={<GiftVouchers />} />
            <Route path="/gift-vouchers/success" element={<GiftVoucherSuccess />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/school/success" element={<SchoolBookingSuccess />} />
            <Route path="/corporate/success" element={<CorporateBookingSuccess />} />
            <Route path="/yesteryear" element={<YesteryearTalks />} />
            <Route path="/yesteryear/success" element={<YesteryearBookingSuccess />} />
            <Route path="/leave-a-review" element={<LeaveReview />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
